import { apiClient } from './client';

export interface Appointment {
  id: number;
  patient_id: number;
  title: string;
  scheduled_at: string;
  duration_minutes: number;
  location: string | null;
  notes: string | null;
  is_cancelled: boolean;
  created_by_user_id: number;
  created_at: string;
}

export async function getAppointments(patientId: number, upcomingOnly = true): Promise<Appointment[]> {
  const response = await apiClient.get<Appointment[]>(`/patients/${patientId}/appointments`, {
    params: { upcoming_only: upcomingOnly },
  });
  return response.data;
}

export async function createAppointment(
  patientId: number,
  data: {
    title: string;
    scheduled_at: string;
    duration_minutes?: number;
    location?: string;
    notes?: string;
  },
): Promise<Appointment> {
  const response = await apiClient.post<Appointment>(`/patients/${patientId}/appointments`, data);
  return response.data;
}